import { trackEvent } from 'utils';
import { CART_STEPS_CATEGORIES, CART_ACTIONS, CART_TRACKING_LABEL } from '../constants/analytics';

export function trackPaymentSubmitDone(method: string): void {
  trackEvent(CART_STEPS_CATEGORIES.PAYMENT, CART_ACTIONS.NEXT, CART_TRACKING_LABEL.click);
  trackEvent(CART_STEPS_CATEGORIES.PAYMENT, CART_ACTIONS.PAYMENT, method);
}

export function trackPaymentSubmitFail(): void {
  trackEvent(CART_STEPS_CATEGORIES.PAYMENT, CART_ACTIONS.NEXT, CART_TRACKING_LABEL.error);
}

export function trackBackToAddressClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.PAYMENT, CART_ACTIONS.BACK, CART_TRACKING_LABEL.click);
}

// Gatsby sends English yes/no here, unlike the German CART_TRACKING_LABEL.yes/no.
export function trackPaymentAvailability(hasPaymentMethodsRestricted: boolean, hasInvoice: boolean): void {
  const allPaymentMethodsAvailable = hasPaymentMethodsRestricted ? 'no' : 'yes';
  const invoiceAvailable = hasInvoice ? 'yes' : 'no';

  trackEvent(
    CART_STEPS_CATEGORIES.PAYMENT,
    CART_ACTIONS.PAYMENT_ALL,
    `${allPaymentMethodsAvailable}_invoice_${invoiceAvailable}`
  );
}
